var _linearGradient, _sodipodiNamedview, _metadata;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 22 22",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "svg2",
    inkscapeVersion: "0.92.1 r15371",
    sodipodiDocname: "dark_warning.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 2,
    x2: 16,
    y1: 29.999973,
    x1: 16,
    id: "linearGradient4144",
    xlinkHref: "#linearGradient4155",
    inkscapeCollect: "always",
    gradientTransform: "matrix(1.66667 0 0 -1.66667 -15.667 1064.696)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    inkscapeCollect: "always",
    id: "linearGradient4155"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcd994",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4157"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff6e1",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop4159"
  }))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 22.4,
    inkscapeCx: -8.3436117,
    inkscapeCy: 10.155389,
    "inkscapeDocument-units": "px",
    "inkscapeCurrent-layer": "layer1",
    showgrid: "true",
    inkscapeShowpageshadow: "false",
    borderlayer: "true",
    "inkscapeWindow-width": 1884,
    "inkscapeWindow-height": 1051,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 0,
    "inkscapeWindow-maximized": 1,
    units: "px"
  }, /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "2,20.000017",
    orientation: "18,0",
    id: "guide4085",
    inkscapeLocked: "false"
  }), /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "2,2.0000174",
    orientation: "0,18",
    id: "guide4087",
    inkscapeLocked: "false"
  }), /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "20,2.0000174",
    orientation: "-18,0",
    id: "guide4089",
    inkscapeLocked: "false"
  }), /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "20,20.000017",
    orientation: "0,-18",
    id: "guide4091",
    inkscapeLocked: "false"
  }), /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "3,19.000017",
    orientation: "16,0",
    id: "guide4093",
    inkscapeLocked: "false"
  }), /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "3,3.0000174",
    orientation: "0,16",
    id: "guide4095",
    inkscapeLocked: "false"
  }), /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "19,3.0000174",
    orientation: "-16,0",
    id: "guide4097",
    inkscapeLocked: "false"
  }), /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "19,19.000017",
    orientation: "0,-16",
    id: "guide4099",
    inkscapeLocked: "false"
  }), /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid4101"
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata7"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", null, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null), /*#__PURE__*/React.createElement("dcCreator", null, /*#__PURE__*/React.createElement("ccAgent", null, /*#__PURE__*/React.createElement("dcTitle", null, "Timoth\xE9e Giet"))), /*#__PURE__*/React.createElement("dcDate", null, "2017"), /*#__PURE__*/React.createElement("ccLicense", {
    rdfResource: "http://creativecommons.org/licenses/by-sa/4.0/"
  })), /*#__PURE__*/React.createElement("ccLicense", {
    rdfAbout: "http://creativecommons.org/licenses/by-sa/4.0/"
  }, /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#Reproduction"
  }), /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#Distribution"
  }), /*#__PURE__*/React.createElement("ccRequires", {
    rdfResource: "http://creativecommons.org/ns#Notice"
  }), /*#__PURE__*/React.createElement("ccRequires", {
    rdfResource: "http://creativecommons.org/ns#Attribution"
  }), /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#DerivativeWorks"
  }), /*#__PURE__*/React.createElement("ccRequires", {
    rdfResource: "http://creativecommons.org/ns#ShareAlike"
  }))))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Capa 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(0 -1030.362)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc35a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m11 1032.362-10 18h20zm0 2 8 15H3z",
    id: "path839",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373737",
      fillOpacity: 0.94117647,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M10 1046.362h2v2h-2z",
    id: "path844",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373737",
      fillOpacity: 0.94117647,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M10 1045.362h2v-6h-2z",
    id: "path846",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4c9861bb2b3669b7f998971d62b33ec3.svg";
export { ForwardRef as ReactComponent };